import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Card, Button, Table } from 'react-bootstrap';

const TutorReport = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { results, totalQuestions } = location.state || { results: [], totalQuestions: 0 };

  if (!results || !results.length) {
    return (
      <Container className="mt-5 text-center">
        <p>No session data available.</p>
        <Button variant="outline-primary" onClick={() => navigate('/dashboard')}>
          Back to Dashboard
        </Button>
      </Container>
    );
  }

  const totalScore = results.reduce((sum, r) => sum + r.score, 0);
  const maxPossibleScore = results.reduce((sum, r) => {
    const max = r.question.mode === 'MC' ? 1 : r.question.correct_answer.split(',').length;
    return sum + max;
  }, 0);
  const averageTime = (results.reduce((sum, r) => sum + r.timeSpent, 0) / results.length).toFixed(2);
  const percentCorrect = ((totalScore / maxPossibleScore) * 100).toFixed(1);

  const incorrectQuestions = results.filter(r => !r.correct).map(r => r.question);

  return (
    <Container className="mt-4" style={{ maxWidth: '800px' }}>
      <h2 className="mb-3">Tutor Session Report</h2>
      <Card className="mb-4">
        <Card.Body>
          <Card.Title>Overall Performance</Card.Title>
          <Table bordered className="mt-3">
            <tbody>
              <tr>
                <td><strong>Total Questions</strong></td>
                <td>{totalQuestions}</td>
              </tr>
              <tr>
                <td><strong>Questions Answered</strong></td>
                <td>{results.length}</td>
              </tr>
              <tr>
                <td><strong>Total Score</strong></td>
                <td>{totalScore} / {maxPossibleScore}</td>
              </tr>
              <tr>
                <td><strong>Percentage</strong></td>
                <td>{percentCorrect}%</td>
              </tr>
              <tr>
                <td><strong>Average Time per Question</strong></td>
                <td>{averageTime}s</td>
              </tr>
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {incorrectQuestions.length > 0 && (
        <div className="text-center mb-3">
          <Button
            variant="warning"
            onClick={() => navigate('/tutor', { state: { questions: incorrectQuestions } })}
          >
            Review Incorrect ({incorrectQuestions.length})
          </Button>
        </div>
      )}

      <Card>
        <Card.Body>
          <Card.Title>Question Details</Card.Title>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Question</th>
                <th>Your Answer</th>
                <th>Correct</th>
                <th>Score</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {results.map((r, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{r.question.question_text.substring(0, 50)}…</td>
                  <td>{r.selected}</td>
                  <td>{r.correct ? '✓' : '✗'}</td>
                  <td>{r.score}</td>
                  <td>{r.timeSpent.toFixed(2)}s</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <div className="mt-3 text-center">
        <Button variant="primary" onClick={() => navigate('/dashboard')}>
          Back to Dashboard
        </Button>
      </div>
    </Container>
  );
};

export default TutorReport;